<script setup lang="ts">
import { ROOT_POLICIES_PAGE, RECORDS_PRICES_URL } from '@/shared/constants/urlConstants';

import { useModalStore } from '@/shared/ui/AppModal/store/modal';

const modalStore = useModalStore();
const route = useRoute();

const isMobile: boolean = useIsMobile();

const isYuristPage: ComputedRef<boolean> = computed(
  () => route.name === 'klienty-yuristu',
);

const showModal = (): void => {
  modalStore.setModalState('contacts', true);
};
</script>

<template>
  <ul :class="['policy-links', { _mobile: isMobile }]">
    <li class="policy-links__item">
      <button
        type="button"
        class="policy-links__button"
        aria-label="Реквизиты"
        @click.prevent="showModal"
      >
        Реквизиты
      </button>
    </li>
    <li v-if="isYuristPage" class="policy-links__item">
      <a
        class="policy-links__link"
        :href="RECORDS_PRICES_URL"
        target="_blank"
        rel="noopener noreferrer"
      >
        Цены записей
      </a>
    </li>
    <li class="policy-links__item">
      <NuxtLink class="policy-links__link" :to="ROOT_POLICIES_PAGE">
        Правовые документы
      </NuxtLink>
    </li>
  </ul>
</template>

<style lang="less">
.policy-links {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 70px;

  &__button {
    .color-change-hover();

    color: white;
  }

  &__link {
    .color-change-hover();

    color: white;
  }

  &__item {
    font-weight: 500;
  }

  &._mobile {
    gap: @size-x3;
    white-space: initial;
    flex-direction: column;
    align-items: flex-start;
  }

  &._mobile &__item {
    font-size: @size-x3;
    line-height: @size-x4;
  }

  &._mobile &__link {
    display: inline-flex;
  }
}
</style>
